import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DPSubscriptionService } from './dp-subscriptions.service';
import { DPTitle } from './model/dp-title';
import { DPMarket } from './model/dp-market';
import { DPAccount } from './dp-account';
import { DPAccountService } from './dp-accounts.service';
import { DPModule } from './model/dp-module';
import { DialogRef, Overlay } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { NotificationsService } from 'angular2-notifications';
import { DPProduct } from './model/dp-product';
import { DPTitleBatchRequest } from './model/dp-title-batch-request';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import { CatalogService } from '../catalogue/catalog-api/catalog.service';
import { EntityType } from '../common/model/constant';

const ALL_ACCESS_ACCOUNT_ID = 99;
@Component({
    templateUrl: 'dp-subscriptions.component.html',
    styleUrls: ['dp-subscriptions.component.css'],

    providers: [Modal]

})
export class DPSubscriptionsComponent implements OnInit {
    csvproduct: DPProduct;
    titles: DPTitle[];
    allTitles: DPTitle[];
    dpmodules: DPModule[];
    fullMarkets: DPMarket[];
    showMarkets: DPMarket[];
    movieMarkets: DPMarket[];
    talentMarkets: DPMarket[];
    sportsMarkets: DPMarket[];
    displayedMarketsToBeAdded: DPMarket[];
    marketFilteredList: DPMarket[];
    marketsMapping: Map<number, boolean>;
    titleLists: DPTitle[];
    accountName: any;
    customerName: any;
    account: DPAccount;
    titlePage = 0;
    gridView = false;
    addingAccount = false;
    errorResponse: any;
    marketErrorResponse: any;
    titleErrorResponse: any;
    moduleErrorResponse: any;
    titleActivity: any;
    marketActivity: any;
    navigated = false; // true if navigated here
    addMarketView = false;
    addTitleView = false;
    addTitleViewBatch = false;
    allTitlePageNumber = 0;
    pageNumbers = new Array();
    addGridView = false;
    query: any;
    filteredList: DPTitle[];
    dialog: any;
    result: any;
    selectedIdx: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    selectedPage = 1;
    queueAvailable = true;
    loadingSubscription = false;
    account_id: any;
    titleQuery: any;
    marketQuery: string;
    processedList: DPTitle[];
    exisitingList: DPTitle[];
    failedList: String[];
    batchLoading = false;
    isFilteredMarketView: boolean;
    subscriptionEntityType: EntityType;
    protected readonly EntityType = EntityType;

    // New matrix view properties
    // marketMatrixData: used to store the state of subscription of all markets in all content types
    // marketId -> (contentType -> state)
    marketMatrixData: Map<number, Map<string, string>>;
    pendingMarketChangesFilter: EntityType = EntityType.SHOW;
    searchMarketQuery: string = '';
    filteredMarketsForMatrix: DPMarket[] = [];
    marketSelectAllStates: Map<number, boolean> = new Map(); // Track if "Select All" is active for each market
    isSubmittingMarkets: boolean = false; // Track submission loading state

    // Manual market entry modal properties
    showEnterMarketsModal: boolean = false;
    manualMarketCodes: string = '';
    manualSelectedContentTypes: { [key: string]: boolean } = {
        [EntityType.SHOW]: true,
        [EntityType.MOVIE]: false,
        [EntityType.TALENT]: false,
        [EntityType.SPORTS]: false
    };


    constructor(
        private toasterService: ToasterService,
        private catalogService: CatalogService,
        private _service: NotificationsService,
        private router: Router,
        private accountService: DPAccountService,
        private subscriptionService: DPSubscriptionService,
        private route: ActivatedRoute,
        public modal: Modal,
        overlay: Overlay,
        vcRef: ViewContainerRef
    ) {

    }

    download() {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const date = new Date();
        a.download = 'Subscription for ' + this.account.account_name + ' ' + date.toDateString();
        const csvData = this.ConvertToCSV(this.titles, this.showMarkets, this.dpmodules);
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.click();
        window.URL.revokeObjectURL(url);
    }
    ConvertToCSV(titlearray: DPTitle[], marketarray: DPMarket[], dpmodulearray: DPModule[]) {
        const tarray = typeof titlearray != 'object' ? JSON.parse(titlearray) : titlearray;
        const marray = typeof marketarray != 'object' ? JSON.parse(marketarray) : marketarray;
        const dmarray = typeof dpmodulearray != 'object' ? JSON.parse(dpmodulearray) : dpmodulearray;

        let str = '';
        const row = 'subscription_reference_id,subscription_name,module_config_value,subscription_type\r\n';
        const titlecsvHeaders: Array<string> = ['parrot_id', 'title'];
        const marketcsvHeaders: Array<string> = ['id', 'description'];
        const modulecsvHeaders: Array<string> = ['product_offering_id', 'product', 'specification_value'];

        str += row;
        for (let i = 0; i < tarray.length; i++) {
            let line = '';
            for (let j = 0; j < titlecsvHeaders.length; j++) {
                if (undefined != tarray[i][titlecsvHeaders[j]]) {
                    if (line != '') line += ',';
                    if (titlecsvHeaders[j] == 'title') {
                        line += '"' + tarray[i][titlecsvHeaders[j]] + '"';

                    } else {
                        line += tarray[i][titlecsvHeaders[j]];

                    }

                } else {
                    if (line != '') line += ',';
                    line += '';
                }
            }
            line += ',,title';
            str += line + '\r\n';
        }
        for (let i = 0; i < marray.length; i++) {
            let line = '';
            for (let j = 0; j < marketcsvHeaders.length; j++) {
                if (undefined != marray[i][marketcsvHeaders[j]]) {
                    if (line != '') line += ',';
                    line += marray[i][marketcsvHeaders[j]];

                } else {
                    if (line != '') line += ',';
                    line += '';
                }
            }
            line += ',,market';
            str += line + '\r\n';
        }
        for (let i = 0; i < dmarray.length; i++) {
            let line = '';
            for (let j = 0; j < modulecsvHeaders.length; j++) {
                if (undefined != dmarray[i][modulecsvHeaders[j]]) {
                    if (line != '') line += ',';
                    if (modulecsvHeaders[j] == 'product') {
                        this.csvproduct = dmarray[i][modulecsvHeaders[j]];
                        line += this.csvproduct.product_offering_id + ',';
                        line += this.csvproduct.product_name;
                    } else {
                        line += dmarray[i][modulecsvHeaders[j]];
                    }
                } else {
                    if (line != '') line += ',';
                    line += '';
                }
            }
            line += ',module';
            str += line + '\r\n';
        }
        return str;
    }


    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        if (error.status == 400 && JSON.parse(error._body).error.code == 4007) {
            this.queueAvailable = true;
            this.batchLoading = false;

        } else {
            this.notificationType = 'error';
            this.notificationTitle = 'Error';
            const jsonErrorBody = JSON.parse(error._body);
            this.notificationContent = jsonErrorBody.error.message;
            this.createNotification();
            this.queueAvailable = true;
            this.batchLoading = false;


        }

    }


    filter(term: string) {
        if (term !== '' && term.length > 2) {
            this.titleQuery = term;
            this.filteredList = this.allTitles.filter(u => u.title.toLowerCase().includes(term.toLowerCase()));
        } else if (!term || term === '') {
            this.filteredList = [];
        }
    }

    filterMarkets() {
        if (this.marketQuery) {
            this.displayedMarketsToBeAdded = this.displayedMarketsToBeAdded.filter(u => u.displayName.toLowerCase().includes(this.marketQuery.toLowerCase()));
        } else {
            this.displayedMarketsToBeAdded = this.marketFilteredList;
        }
    }

    getMarkets() {
        return this.subscriptionService
            .getMarkets()
            .then(res => {
                this.fullMarkets = res.subscriptions.markets.filter(market => market.demandOnly === 1);
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }


    getAccount(account_id: number) {
        return this.accountService
            .getAccount(account_id)
            .then(res => this.account = res);
    }

    getSubscriptions(account_id: number) {
        this.titles = [];
        this.showMarkets = [];
        this.movieMarkets = [];
        this.talentMarkets = [];
        this.sportsMarkets = [];
        this.dpmodules = [];
        this.loadingSubscription = true;
        return this.subscriptionService
            .getSubscriptions(account_id)
            .then(res => {
                this.titles = res.subscriptions.titles;

                this.showMarkets = res.subscriptions.markets || [];

                this.dpmodules = res.subscriptions.modules;

                this.movieMarkets = res.subscriptions.movie_markets || [];

                this.talentMarkets = res.subscriptions.talent_markets || [];

                this.sportsMarkets = res.subscriptions.sports_markets || [];

                this.loadingSubscription = false;

                console.log("showMarkets:", this.showMarkets);
                console.log("movieMarkets:", this.movieMarkets);
                console.log("talentMarkets:", this.talentMarkets);
                console.log("sportsMarkets:", this.sportsMarkets);

            })
            .catch(error => {
                this.loadingSubscription = false;
                this.errorHandler(error);
            });
    }

    getAllTitles() {
        return this.subscriptionService
            .getAllTitles()
            .then(res => {
                this.allTitles = res.subscriptions.titles;
                this.titleLists = [];
            })
            .catch(error => this.errorHandler(error));
    }

    addTitle(title: DPTitle, event: any) {
        if (this.queueAvailable == true) {
            this.queueAvailable = false;
            this.subscriptionService
                .addTitle(title, this.account.account_id)
                .then(res => {
                    this.getSubscriptions(this.account.account_id);
                    if (this.account.account_id === ALL_ACCESS_ACCOUNT_ID) {
                        this.catalogService.updateGenome([title.parrot_id], ['catalog_state'], ['client_ready'], 'tv')
                            .then(() => {
                                this.titleQuery = undefined;
                                this.allTitles = this.allTitles.filter(u => u.parrot_id !== title.parrot_id);
                                this.notificationType = 'success';
                                this.notificationTitle = 'Successful';
                                this.notificationContent = 'Title : ' + title.title + ' is added';
                                this.createNotification();
                                this.titleLists = this.titleLists.filter(u => u.parrot_id !== title.parrot_id);
                                this.queueAvailable = true;
                            })
                            .catch((message) => {
                                this.toasterService.pop('error', message);
                            });
                    } else {
                        this.getSubscriptions(this.account.account_id);
                        this.titleQuery = undefined;
                        this.allTitles = this.allTitles.filter(u => u.parrot_id !== title.parrot_id);
                        this.notificationType = 'success';
                        this.notificationTitle = 'Successful';
                        this.notificationContent = 'Title : ' + title.title + ' is added';
                        this.createNotification();
                        this.titleLists = this.titleLists.filter(u => u.parrot_id !== title.parrot_id);
                        this.queueAvailable = true;
                    }
                })
                .catch(error => this.errorHandler(error));
        }
    }
    clickRefresh() {
        this.getSubscriptions(this.account.account_id);
    }
    deleteTitle(title: DPTitle, event: any) {
        this.subscriptionService
            .deleteTitle(title.parrot_id, this.account.account_id)
            .then(res => {
                this.getSubscriptions(this.account.account_id);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Title : ' + title.title + ' is deleted';
                this.createNotification();
                this.queueAvailable = true;
                //  console.log(this.queueAvailable);

            })
            .catch(error => this.errorHandler(error));
    }

    deleteMarket(market: DPMarket, event: any) {
        this.subscriptionService
            .deleteMarket(market.id, this.account.account_id, this.subscriptionEntityType)
            .then(res => {
                this.getSubscriptions(this.account.account_id);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Market : ' + market.displayName + ' is deleted';
                this.createNotification();
                this.queueAvailable = true;

            })
            .catch(error => this.errorHandler(error));
    }

    deleteModule(dpmodule: DPModule, event: any) {
        this.subscriptionService
            .deleteModule(dpmodule.product.product_offering_id, this.account.account_id)
            .then(res => {
                this.getSubscriptions(this.account.account_id);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Module : ' + dpmodule.product.product_name + ' is deleted';
                this.createNotification();
                this.queueAvailable = true;

            })
            .catch(error => this.errorHandler(error));
    }


    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            this.titles = [];
            this.showMarkets = [];
            this.dpmodules = [];
            this.account_id = params['account_id'];
            this.navigated = true;
            localStorage.setItem('accountId', params['account_id']);

        });
        this.getSubscriptions(this.account_id);
        this.getAccount(this.account_id);
        this.getMarkets();
        this.getAllTitles();
        this.subscriptionEntityType = EntityType.SHOW;
        this.marketsMapping = new Map<number, boolean>();
        this.marketMatrixData = new Map<number, Map<string, string>>();
        this.filteredMarketsForMatrix = [];
    }

    getPageNumbers(currentPage: number) {
        const pages = new Array();
        let start = currentPage - 5;
        if (start <= 0) {
            start = 1;
        }

        let end = start + 10;
        if (end > this.allTitlePageNumber) {
            end = this.allTitlePageNumber;
            start = end - 10;
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return pages;
    }


    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account', this.account.customer.customer_id]);
        }
    }

    selectTitle() {
        this.titlePage = 0;
        this.addTitleView = false;
        this.addMarketView = false;

    }

    selectShowMarkets() {
        this.titlePage = 1;
        this.addTitleView = false;
        this.addMarketView = false;
        this.subscriptionEntityType = EntityType.SHOW;
    }

    selectMovieMarkets() {
        this.titlePage = 1;
        this.addTitleView = false;
        this.addMarketView = false;
        this.subscriptionEntityType = EntityType.MOVIE;
    }
    selectTalentMarkets() {
        this.titlePage = 1;
        this.addTitleView = false;
        this.addMarketView = false;
        this.subscriptionEntityType = EntityType.TALENT;
    }
    selectSportsMarkets() {
        this.titlePage = 1;
        this.addTitleView = false;
        this.addMarketView = false;
        this.subscriptionEntityType = EntityType.SPORTS;
    }

    selectModule() {
        this.titlePage = 2;
        this.addTitleView = false;
        this.addMarketView = false;
    }

    selectGrid() {
        this.gridView = true;
    }

    selectList() {
        this.gridView = false;
    }

    selectAddMarkets() {
        this.marketErrorResponse = undefined;
        this.addMarketView = true;
        this.initializeMatrixView();
        this.marketsMapping = new Map<number, boolean>();
        this.isFilteredMarketView = false;
    }

    private initializeMatrixView() {
        this.marketMatrixData = new Map<number, Map<string, string>>();
        this.filteredMarketsForMatrix = [...this.fullMarkets];

        // Initialize matrix with existing subscriptions
        this.fullMarkets.forEach(market => {
            const marketMap = new Map<string, string>();

            // Check if market exists for each content type
            if (this.showMarkets.some(m => m.id === market.id)) {
                marketMap.set(EntityType.SHOW, 'existing');
            }
            if (this.movieMarkets.some(m => m.id === market.id)) {
                marketMap.set(EntityType.MOVIE, 'existing');
            }
            if (this.talentMarkets.some(m => m.id === market.id)) {
                marketMap.set(EntityType.TALENT, 'existing');
            }
            if (this.sportsMarkets.some(m => m.id === market.id)) {
                marketMap.set(EntityType.SPORTS, 'existing');
            }

            this.marketMatrixData.set(market.id, marketMap);
        });
    }

    /**
     * Used to render the state of checkbox in the matrix
     * For each marketId will map to <contentType, state>
     * @param marketId 
     * @param contentType 
     * @returns 
     */
    getMatrixCellState(marketId: number, contentType: EntityType): string {
        const marketMap = this.marketMatrixData.get(marketId);
        if (!marketMap) return 'unchecked';
        return marketMap.get(contentType) || 'unchecked';
    }

    /**
     * Get the marketId and the content type where the checkbox belongs to.
     * Toggle market checkbox state when the user clicks it.
     * @param marketId 
     * @param contentType 
     * @returns 
     */
    toggleMatrixCell(marketId: number, contentType: EntityType) {
        const marketMap = this.marketMatrixData.get(marketId);
        if (!marketMap) return;

        const currentState = marketMap.get(contentType) || 'unchecked';

        // Don't allow toggling existing subscriptions
        if (currentState === 'existing') return;

        // Toggle between unchecked and pending
        if (currentState === 'unchecked') {
            marketMap.set(contentType, 'pending');
        } else {
            marketMap.set(contentType, 'unchecked');
        }

        // Update the select all state based on current selections
        this.updateSelectAllState(marketId);
    }

    /**
     * Check if all non-existing content types are selected for a market to decide whether to update select all button state
     * allNonExistingArePending && hasAnyPending === true --> show unselect all, otherwise show select all
     * only when all the types are checked, and it is not all the types have already existed, it will show unselect all
     * @param marketId 
     * @returns 
     */
    private updateSelectAllState(marketId: number) {
        const marketMap = this.marketMatrixData.get(marketId);
        if (!marketMap) return;

        // Check if all non-existing content types are selected (pending)
        const allNonExistingArePending = [EntityType.SHOW, EntityType.MOVIE, EntityType.TALENT, EntityType.SPORTS].every(contentType => {
            const state = marketMap.get(contentType) || 'unchecked';
            // If all the state is existing or pending, then return true. Any "unchecked" state will return false
            return state === 'existing' || state === 'pending';
        });

        // Also check if there's at least one pending (to distinguish from all unchecked)
        const hasAnyPending = [EntityType.SHOW, EntityType.MOVIE, EntityType.TALENT, EntityType.SPORTS].some(contentType => {
            const state = marketMap.get(contentType) || 'unchecked';
            return state === 'pending';
        });

        this.marketSelectAllStates.set(marketId, allNonExistingArePending && hasAnyPending);
    }

    selectAllForMarket(marketId: number) {
        const marketMap = this.marketMatrixData.get(marketId);
        if (!marketMap) return;

        const isCurrentlySelected = this.marketSelectAllStates.get(marketId) || false;

        if (isCurrentlySelected) {
            // isCurrentlySelected == true -> Unselect all - set all pending to unchecked (but keep existing)
            [EntityType.SHOW, EntityType.MOVIE, EntityType.TALENT, EntityType.SPORTS].forEach(contentType => {
                const state = marketMap.get(contentType) || 'unchecked';
                if (state === 'pending') {
                    marketMap.set(contentType, 'unchecked');
                }
            });
            this.marketSelectAllStates.set(marketId, false);
        } else {
            // Select all - set all non-existing to pending (checked)
            [EntityType.SHOW, EntityType.MOVIE, EntityType.TALENT, EntityType.SPORTS].forEach(contentType => {
                const state = marketMap.get(contentType) || 'unchecked';
                if (state !== 'existing') {
                    marketMap.set(contentType, 'pending');
                }
            });
            this.marketSelectAllStates.set(marketId, true);
        }
    }

    isMarketFullySelected(marketId: number): boolean {
        return this.marketSelectAllStates.get(marketId) || false;
    }

    /**
     * checking the markets selected by the user （state is pending)
     * @returns 
     */
    getPendingMarketChanges(): Array<{ market: DPMarket, contentType: EntityType }> {
        const pending: Array<{ market: DPMarket, contentType: EntityType }> = [];

        this.marketMatrixData.forEach((marketMap, marketId) => {
            const market = this.fullMarkets.find(m => m.id === marketId);
            if (!market) return;

            marketMap.forEach((state, contentType) => {
                if (state === 'pending') {
                    pending.push({ market, contentType: contentType as EntityType });
                }
            });
        });

        return pending;
    }

    getPendingMarketChangesForFilter(contentType: EntityType): Array<{ market: DPMarket, contentType: EntityType }> {
        return this.getPendingMarketChanges().filter(p => p.contentType === contentType);
    }

    /**
     * Group pending changes by market, showing all content types for each market
     * Returns array of objects with market and comma-separated content types
     * @returns 
     */
    groupPendingChangesByMarket(): Array<{ market: DPMarket, contentTypes: string[] }> {
        const grouped = new Map<number, { market: DPMarket, contentTypes: Set<string> }>();

        this.getPendingMarketChanges().forEach(pending => {
            if (!grouped.has(pending.market.id)) {
                grouped.set(pending.market.id, {
                    market: pending.market,
                    contentTypes: new Set<string>()
                });
            }
            grouped.get(pending.market.id).contentTypes.add(pending.contentType);
        });

        return Array.from(grouped.values()).map(item => ({
            market: item.market,
            contentTypes: Array.from(item.contentTypes).sort()
        }));
    }

    removeAllSelectedMarkets() {
        // Reset all pending selections to unchecked
        this.marketMatrixData.forEach((marketMap) => {
            marketMap.forEach((state, contentType) => {
                if (state === 'pending') {
                    marketMap.set(contentType, 'unchecked');
                }
            });
        });
        // Reset all select all states
        this.marketSelectAllStates.clear();
    }

    filterMarketsForMatrix() {
        if (this.searchMarketQuery && this.searchMarketQuery.length > 0) {
            this.filteredMarketsForMatrix = this.fullMarkets.filter(m =>
                m.displayName.toLowerCase().includes(this.searchMarketQuery.toLowerCase())
            );
        } else {
            this.filteredMarketsForMatrix = [...this.fullMarkets];
        }
    }

    /**
     * Submit the selected markets from the matrix view, supporting adding markets to multiple types
     * replace the old addMarkets() function
     * @returns 
     */
    submitSelectedMarkets() {
        const pending = this.getPendingMarketChanges();

        if (pending.length === 0) {
            this.notificationType = 'info';
            this.notificationTitle = 'No Changes';
            this.notificationContent = 'No pending market selections to submit';
            this.createNotification();
            return;
        }

        this.isSubmittingMarkets = true;

        // Group by content type for sending request
        const groupedByType = new Map<EntityType, number[]>(); // <number> refer to market refId
        pending.forEach(p => {
            if (!groupedByType.has(p.contentType)) {
                groupedByType.set(p.contentType, []);
            }
            groupedByType.get(p.contentType).push(p.market.id);
        });

        console.log("prepare to submit the selected markets,", groupedByType)
        // Submit each content type
        let submitted = 0;
        groupedByType.forEach((marketIds, contentType) => {
            this.subscriptionService
                .addMarkets(this.account.account_id, marketIds, contentType)
                .then(res => {
                    submitted++;
                    if (submitted === groupedByType.size) {
                        this.isSubmittingMarkets = false;
                        this.getSubscriptions(this.account.account_id);
                        this.notificationType = 'success';
                        this.notificationTitle = 'Successful';
                        this.notificationContent = `${pending.length} market-type relations have been added`;
                        this.createNotification();
                        this.selectDoneMarkets();
                    }
                })
                .catch(error => {
                    this.isSubmittingMarkets = false;
                    this.errorHandler(error);
                });
        });
    }

    // Commented this since currnetly not used in the new market management because we are listing all the markets
    // private getDisplayedMarketsToBeAdded() {
    //     return this.fullMarkets.filter(
    //         fullMarket => !(this.getCurrentMarketList().some(market => market.id === fullMarket.id))
    //     );
    // }

    getCurrentMarketList(): DPMarket[] {
        if (this.subscriptionEntityType === EntityType.SHOW) {
            return this.showMarkets;
        } else if (this.subscriptionEntityType === EntityType.MOVIE) {
            return this.movieMarkets;
        } else if (this.subscriptionEntityType === EntityType.TALENT) {
            return this.talentMarkets;
        } else {
            return this.sportsMarkets;
        }
    }

    clickBack() {
        this.marketErrorResponse = undefined;
        this.marketActivity = undefined;
        this.addMarketView = false;
    }

    selectDoneMarkets() {
        this.marketErrorResponse = undefined;
        this.clickRefresh();
        this.marketActivity = undefined;
        this.addMarketView = false;
    }





    selectAddTitle() {
        this.addTitleView = true;
        this.titleErrorResponse = undefined;
        if (this.titles !== undefined) {
            this.titles.forEach(title => this.titleLists = this.titleLists.filter(u => u.parrot_id !== title.parrot_id));
        }
        this.pageNumbers = this.getPageNumbers(1);

    }

    selectAddTitleBatch() {
        this.addTitleViewBatch = true;
        this.titleErrorResponse = undefined;

    }
    selectDoneTitle() {
        this.clickRefresh();
        this.titleErrorResponse = undefined;
        this.titleActivity = undefined;
        this.addTitleView = false;
        this.addTitleViewBatch = false;
        this.failedList = undefined;
        this.processedList = undefined;
        this.exisitingList = undefined;

    }

    selectAddGrid() {
        this.addGridView = false;
    }

    selectAddList() {
        this.addGridView = false;
    }

    selectCreateModule() {
        this.router.navigate(['demandportal/customer/account/subscriptions/modulecreate', this.account.account_id]);
    }

    selectModuleDetail(dpModule: DPModule) {
        this.router.navigate(['demandportal/customer/account/subscriptions/moduledetail', this.account.account_id, dpModule.product.product_offering_id]);

    }

    onClickDeleteMarket(market: DPMarket, event: any) {
        if (this.queueAvailable === true) {
            event.stopPropagation();
            this.queueAvailable = false;

            this.dialog = this.modal.confirm()
                .size('sm')
                .isBlocking(false)
                .showClose(false)
                .keyboard(27)
                .body('You really want to delete the market?')
                .okBtn('Yes')
                .cancelBtn('No')
                .open();


            this.processDialogMarket(market, event, this.dialog);
        }
    }
    private processDialogMarket(market: DPMarket, event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this.deleteMarket(market, event);
                this.result = result;
            }, () => {
                this.queueAvailable = true;
                this.result = 'Rejected!';
            });
        });
    }
    onClickDeleteTitle(title: DPTitle, event: any) {
        if (this.queueAvailable === true) {
            event.stopPropagation();
            this.queueAvailable = false;

            this.dialog = this.modal.confirm()
                .size('sm')
                .isBlocking(false)
                .showClose(false)
                .keyboard(27)
                .body('You really want to delete the title?')
                .okBtn('Yes')
                .cancelBtn('No')
                .open();


            this.processDialogTitle(title, event, this.dialog);
        }
    }
    private processDialogTitle(title: DPTitle, event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this.deleteTitle(title, event);
                this.result = result;
            }, () => {
                this.queueAvailable = true;
                this.result = 'Rejected!';
            });
        });
    }
    onClickDeleteModule(dpmodule: DPModule, event: any) {
        if (this.queueAvailable === true) {
            event.stopPropagation();
            this.queueAvailable = false;
            this.dialog = this.modal.confirm()
                .size('sm')
                .isBlocking(false)
                .showClose(false)
                .keyboard(27)
                .body('You really want to delete the module?')
                .okBtn('Yes')
                .cancelBtn('No')
                .open();


            this.processDialogModule(dpmodule, event, this.dialog);
        }
    }
    private processDialogModule(dpmodule: DPModule, event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this.deleteModule(dpmodule, event);
                this.result = result;
            }, () => {
                this.queueAvailable = true;
                this.result = 'Rejected!';
            });
        });
    }

    handleBlur() {
        setTimeout(() => {
            this.filteredList = [];
        }, 200);
    }
    processBatchTitles(titleIds: String) {
        //  console.log(this.titles);
        const titleIdList = titleIds.split(',');
        this.processedList = new Array<DPTitle>();
        this.exisitingList = new Array<DPTitle>();
        this.failedList = new Array<String>();

        for (const id of titleIdList) {

            const title = this.allTitles.find(t => t.parrot_id === id);
            const foundTitle = this.titles.find(t => t.parrot_id === id);
            //  console.log(foundTitle);
            if (title !== undefined && foundTitle === undefined) {
                this.processedList.push(title);
            } else if (foundTitle !== undefined) {
                this.exisitingList.push(foundTitle);
            } else {
                this.failedList.push(id);
            }
        }

        if (this.processedList.length > 0) {
            this.processedList.sort(function (a, b) {
                if (a.title < b.title) { return -1; }
                if (a.title > b.title) { return 1; }
                return 0;
            });
        }

    }

    saveTitlesBatch() {
        if (this.processedList !== undefined) {
            if (this.processedList.length > 0) {
                this.batchLoading = true;

                const titleRequest = new DPTitleBatchRequest();
                titleRequest.titles = new Array<string>();
                this.processedList.forEach(t => titleRequest.titles.push(t.parrot_id));
                //   console.log(titleRequest);


                if (this.queueAvailable == true) {
                    this.queueAvailable = false;
                    this.subscriptionService
                        .addTitleBatch(titleRequest, this.account.account_id)
                        .then(res => {
                            this.getSubscriptions(this.account.account_id);
                            if (this.account.account_id === ALL_ACCESS_ACCOUNT_ID) {
                                this.catalogService.updateGenome(
                                    titleRequest.titles, ['data_state'], Array(titleRequest.titles.length).fill('cust_ready'), 'tv'
                                )
                                    .then(() => {
                                        this.titleQuery = undefined;
                                        this.notificationType = 'success';
                                        this.notificationTitle = 'Successful';
                                        this.notificationContent = this.processedList.length + ' titles added';
                                        this.createNotification();
                                        this.queueAvailable = true;
                                        this.batchLoading = false;
                                        this.selectDoneTitle();
                                    })
                                    .catch((message) => {
                                        this.toasterService.pop('error', message);
                                    });
                            } else {
                                this.titleQuery = undefined;
                                this.notificationType = 'success';
                                this.notificationTitle = 'Successful';
                                this.notificationContent = this.processedList.length + ' titles added';
                                this.createNotification();
                                this.queueAvailable = true;
                                this.batchLoading = false;
                                this.selectDoneTitle();
                            }
                        })
                        .catch(error => this.errorHandler(error));
                }

            }
        }

    }

    /**
     * Open the manual market entry modal
     */
    onClickEnterMarketsManually() {
        this.showEnterMarketsModal = true;
        this.manualMarketCodes = '';
        this.manualSelectedContentTypes = {
            [EntityType.SHOW]: true,
            [EntityType.MOVIE]: false,
            [EntityType.TALENT]: false,
            [EntityType.SPORTS]: false
        };
    }

    /**
     * Close the manual market entry modal
     */
    closeEnterMarketsModal() {
        this.showEnterMarketsModal = false;
        this.manualMarketCodes = '';
    }

    /**
     * Apply manual market entries to the matrix
     * Validates format and ISO codes, then updates the matrix checkboxes
     */
    applyManualMarkets() {
        // Validate that at least one content type is selected
        const selectedTypes = Object.keys(this.manualSelectedContentTypes).some(key => this.manualSelectedContentTypes[key]);
        if (!selectedTypes) {
            this.notificationType = 'error';
            this.notificationTitle = 'Error';
            this.notificationContent = 'Please select at least one content type';
            this.createNotification();
            return;
        }

        // Parse and validate market codes
        const codes = this.manualMarketCodes
            .split('\n')
            .map(code => code.trim().toUpperCase())
            .filter(code => code.length > 0);

        if (codes.length === 0) {
            this.notificationType = 'error';
            this.notificationTitle = 'Error';
            this.notificationContent = 'Please enter at least one ISO country code';
            this.createNotification();
            return;
        }

        // Validate ISO format (2 letters)
        const isoRegex = /^[A-Z]{2}$/;
        const invalidCodes = codes.filter(code => !isoRegex.test(code));
        if (invalidCodes.length > 0) {
            this.notificationType = 'error';
            this.notificationTitle = 'Error';
            this.notificationContent = `Invalid format. The following codes are not valid: ${invalidCodes.join(', ')}. You need to use line-separated format and ISO codes must be exactly 2 letters.`;
            this.createNotification();
            return;
        }

        // Find matching markets by ISO code from this.fullMarket
        const matchedMarkets: DPMarket[] = [];
        const notFoundCodes: string[] = [];

        codes.forEach(code => {
            const market = this.fullMarkets.find(m => m.iso && m.iso.toUpperCase() === code);
            if (market) {
                matchedMarkets.push(market);
            } else {
                notFoundCodes.push(code);
            }
        });

        if (matchedMarkets.length === 0) {
            this.notificationType = 'error';
            this.notificationTitle = 'Error';
            this.notificationContent = `No markets found for the provided ISO codes: ${codes.join(', ')}`;
            this.createNotification();
            return;
        }

        // Update matrix for matched markets
        let updatedCount = 0;
        matchedMarkets.forEach(market => {
            const marketMap = this.marketMatrixData.get(market.id);
            if (!marketMap) return;

            // For each selected content type, update the checkbox if it's not already existing
            Object.keys(this.manualSelectedContentTypes).forEach(contentType => {
                if (this.manualSelectedContentTypes[contentType]) {
                    const currentState = marketMap.get(contentType) || 'unchecked';
                    // Only update if it's not already existing
                    if (currentState !== 'existing') {
                        marketMap.set(contentType, 'pending');
                        updatedCount++;
                    }
                }
            });

            // Update the select all state for this market
            this.updateSelectAllState(market.id);
        });

        // Show success notification
        let message = `${matchedMarkets.length} market(s) selected. Please make sure you submit the change.`;
        if (notFoundCodes.length > 0) {
            message += ` (${notFoundCodes.length} code(s) not found: ${notFoundCodes.join(', ')})`;
        }
        this.notificationType = 'success';
        this.notificationTitle = 'Markets selected';
        this.notificationContent = message;
        this.createNotification();

        // Close the modal
        this.closeEnterMarketsModal();
    }

}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-subscriptions.component.ts